import get from "lodash.get";

export function alphabetically(ascending?: boolean, key?: string | string[]) {
  return function (ax: any, bx: any) {
    let a = ax;
    let b = bx;

    if (!!key) {
      a = get(ax, key) || null;
      b = get(bx, key) || null;
    }
    // equal items sort equally
    if (a === b) {
      return 0;
    }

    // nulls sort after anything else
    if (a === null) {
      return -1;
    }
    if (b === null) {
      return -1;
    }

    // otherwise, if we're ascending, lowest sorts first
    if (ascending) {
      return a < b ? -1 : 1;
    }

    // if descending, highest sorts first
    return a < b ? 1 : -1;
  };
}